import dynamicComponent from "./dynamicComponent.js";

export default {
  install(app) {
    app.directive("dynamic-component", dynamicComponent);
  },
};
